import "./App.css";
import React, { Suspense, lazy, useEffect, useState } from "react";
// import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import "./assets/css/typography.css";
import "./assets/css/page.css";
import "./assets/css/content.css";

import Mainpage from "./pages/Mainpage.js";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Service from "./pages/service/Service";
import News from "./pages/news/News";
import NewsAll from "./pages/news/NewsAll";
import Appointment from "./pages/appointment/Appointment";
import ContactUs from "./pages/about/ContactUs";
import Staff from "./pages/about/Staff";
import AboutUs from "./pages/about/AboutUs";
import Article from "./pages/resource/Article";
import Infographic from "./pages/resource/Infographic";
import Gallery from "./pages/resource/gallery/Gallery";
import Document from "./pages/resource/Document";
// import NavbarService from "./services/navbar";
import ServiceDetail from "./pages/service/ServiceDetail";
import TemplateService from "./services/template";
import Video from "./pages/resource/video/Video";
import GalleryDetail from "./pages/resource/gallery/GalleryDetail";
import VideoDetail from "./pages/resource/video/VideoDetail";
import ActivityAll from "./pages/news/ActivityAll";
import AppointmentDetail from "./pages/appointment/AppointmentDetail";
import ContentDetail from "./pages/ContentDetail";
import Hamburger from "./components/Hamburger";
import Search from "./pages/Search";
import SearchKeyword from "./pages/SearchKeyword";
import Preview from "./pages/Preview";
import Voc from "./pages/voc/Voc";
import ComingSoon from "./pages/ComingSoon";
// โหลดหน้าแอดมินแยกก้อน เพราะมันลากตัวแก้ข้อความกับตัวเขียนไฟล์ Excel
// มาด้วยราว 80 kB ซึ่งคนที่เข้าเว็บทั่วไปไม่ได้ใช้เลย
const VocAdmin = lazy(() => import("./pages/voc/VocAdmin"));

function App() {
  let [templateData, setTemplateData] = useState([]);

  useEffect(() => {
    getTemplateData();
  }, []);

  const getTemplateData = async () => {
    try {
      let res = await TemplateService.getTemplate();
      setTemplateData(res);
    } catch {
      console.error();
    }
  };

  return (
    <BrowserRouter>
      <Switch>
        {/* หน้าแอดมิน VOC — ไม่มี navbar/footer ของเว็บหลัก มี layout ของตัวเอง
            ต้องมาก่อน /:lang ไม่งั้นจะถูกมองว่า voc-admin เป็นรหัสภาษา */}
        <Route exact path="/voc-admin">
          <Suspense fallback={<div className="p-[40px] text-center">กำลังโหลด...</div>}>
            <VocAdmin />
          </Suspense>
        </Route>

        {/* Preview Route MUST be before /:lang */}
        <Route exact path="/preview">
          <Preview />
        </Route>

        <Route exact path="/:lang">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Mainpage />
            <Footer data={templateData} />
          </div>
        </Route>

        {/* Service */}
        <Route exact path="/:lang/service">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Service />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/service/:id">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ServiceDetail />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path={`/:lang/newsAndActivity`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <News />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path={`/:lang/newsAndActivity/news`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <NewsAll />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/newsAndActivity/news/:slug`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContentDetail page="news" />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path={`/:lang/newsAndActivity/activity`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ActivityAll />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/newsAndActivity/activity/:slug`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContentDetail page="activities" />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/appointment">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Appointment />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/appointment/:id`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <AppointmentDetail />
            <Footer data={templateData} />
          </div>
        </Route>

        {/* VOC — Voice of Customer
            ยังไม่มี design ว่าจะลิงก์มาจากเมนูไหน จึงแยก path ไว้ก่อน
            เข้าตรงที่ /th/voc */}
        <Route exact path="/:lang/voc">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Voc />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/contact-us">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContactUs />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/about-us">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <AboutUs />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/staff">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Staff />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/article">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Article />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/article/:slug`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContentDetail page="article" />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/infographic">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Infographic />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path={`/:lang/infographic/:slug`}>
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ContentDetail page="infographic" />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/gallery">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Gallery />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/gallery/:slug">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <GalleryDetail />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="/:lang/video">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Video />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/video/:slug">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <VideoDetail />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/document">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Document />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/search/:tag">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <Search />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route path="/:lang/search-keyword/:keyword">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <SearchKeyword />
            <Footer data={templateData} />
          </div>
        </Route>

        {/* path ที่ยังไม่มีหน้า (เช่นเมนูที่แอดมินเพิ่มไว้ก่อนทำหน้า) -> หน้า "เร็วๆ นี้"
            แทนการเด้งกลับหน้าแรก */}
        <Route path="/:lang">
          <div className="App">
            <Navbar data={templateData} />
            <Hamburger data={templateData} />
            <ComingSoon />
            <Footer data={templateData} />
          </div>
        </Route>

        <Route exact path="*">
          <Redirect to="/th" />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
